// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-accordion-list-item {
  display: flex;
  margin: 25px 0;
}

.simx-accordion-list-item--actions-block {
  display: flex;
  flex-grow: 0;
  padding-top: 3px;
}

.simx-accordion-list-item--action {
  display: flex;
  height: 32px;
  width: 32px;
  margin: 0 5px;
}
.simx-accordion-list-item--action:first-of-type {
  margin-left: 0;
}
.simx-accordion-list-item--action:last-of-type {
  margin-right: 10px;
}

.simx-accordion-list-item--content-block {
  border: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  border-radius: 4px;
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/controls/accordion-list/accordion-list-item/accordion-list-item.component.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAFF;AAGE;EACE,cAAA;AADJ;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,qEAAA;EACA,kBC7B4B;ED8B5B,YAAA;AAFF","sourcesContent":["@use 'colors';\n@use 'theme';\n\n.simx-accordion-list-item {\n  display: flex;\n  margin: 25px 0;\n}\n\n.simx-accordion-list-item--actions-block {\n  display: flex;\n  flex-grow: 0;\n  padding-top: 3px;\n}\n\n.simx-accordion-list-item--action {\n  display: flex;\n  height: 32px;\n  width: 32px;\n  margin: 0 5px;\n  &:first-of-type {\n    margin-left: 0;\n  }\n  &:last-of-type {\n    margin-right: 10px;\n  }\n}\n\n.simx-accordion-list-item--content-block {\n  border: solid 1px colors.$simxColorLightNeutralDark;\n  border-radius: theme.$simxBorderRadiusDefault;\n  flex-grow: 1;\n}\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
